import React from 'react';
import { EditorProvider } from '../utils/editorProvider/editorProvider';
import { ApplicationContext } from '../utils/applicationContext';
import { IApplicationContext } from '../types/applicationContext';

interface IReactComponentWrapperProps {
  isEditor: boolean;
  context: IApplicationContext;
  // eslint-disable-next-line
  component: React.ComponentType<any>;
  // eslint-disable-next-line
  props?: Record<string, any>;
  children?: React.ReactNode;
}

/**
 * Компонент-обертка для упрощения создания React-компонентов в GrapesJS
 * Автоматически оборачивает компонент в необходимые провайдеры
 */
export const ReactComponentWrapper: React.FC<IReactComponentWrapperProps> = ({
  isEditor,
  context,
  component: Component,
  props = {},
  children,
}) => {
  return (
    <EditorProvider isEditor={isEditor}>
      <ApplicationContext.Provider value={context}>
        <Component {...props}>{children}</Component>
      </ApplicationContext.Provider>
    </EditorProvider>
  );
};
